<h2 mat-dialog-title>No Matching {{ data.productName }} Found</h2>

<mat-dialog-content>
  <p>
    We do not offer any <strong>{{ data.selection | stringFormat:data.selection.format}}</strong> {{ data.productName.toLowerCase() }}
  that are @for (otherSelection of data.otherSelections; track otherSelection; let idx = $index) {<span>
    {{ otherSelection | stringFormat:otherSelection.format}}{{ idx < data.otherSelections.length -1 ? ' and ' : '.'}}
  </span>}
  </p>
  <p>
    If you choose to keep these changes, some of your selections will be changed to find the closest matching
    <strong>{{ data.selection | stringFormat:data.selection.format}}</strong> {{ data.productName.toLowerCase() }}
    we offer.
  </p>
</mat-dialog-content>

<mat-dialog-actions class="fx-layout-row fx-align--space-between">
  <!--
  <button mat-flat-button color="primary" mat-dialog-close="keep">See <strong>{{ data.selection | stringFormat:data.selection.format}}</strong> {{ data.productName }}</button>
  -->
  <button mat-flat-button color="primary" mat-dialog-close="keep">
    Keep Changes
  </button>

  <button mat-flat-button color="secondary" mat-dialog-close>
    Undo
  </button>

</mat-dialog-actions>
